export const daysUntilCertificationExpiry = (expiryDate: string, now = Date.now()) => Math.ceil((new Date(expiryDate).getTime() - now) / (1000 * 60 * 60 * 24));

export const isCertificationExpiring = (
  expiryDate: string | undefined,
  largestReminderPeriodInDays: number,
): boolean => {

  if (!expiryDate) return false;
  return daysUntilCertificationExpiry(expiryDate) <= largestReminderPeriodInDays;

};

export const isCertificationExpiringByDays = (
  daysUntilExpiry: number,
  largestReminderPeriodInDays: number,
) => daysUntilExpiry <= largestReminderPeriodInDays;

export const certificationExpiryChipColor = (
  days: number,
  largestReminderPeriodInDays: number,
): 'primary' | 'warning' | 'error' => {

  if (days > largestReminderPeriodInDays) return 'primary';
  if (days < 0) return 'error';
  return 'warning';

};

export const getCertificationExpiryText = (
  days: number,
  translate: (key: string, options?: { smart_count?: number }) => string,
) => {

  if (days === 0) {

    return translate('resources.certification-categories.text.expires_today');

  }

  if (days < 0) {

    return translate('resources.certification-categories.text.already_expired_for', {
      smart_count: Math.abs(days),
    });

  }
  return translate('resources.certification-categories.text.days_until_expiry', {
    smart_count: days,
  });

};
